import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

registerFragment('cbdce-body-text', (fragEl, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
}
